import React from 'react';
import { colors } from '../../styles/styles';

// Purple CTA used across the drafts surface. Two visual variants:
//   - 'filled'  (default): solid purple + soft glow — primary action
//   - 'outline': transparent background, purple border + text — quieter
const PrimaryButton = ({
  onClick,
  disabled = false,
  fullWidth = false,
  variant = 'filled',
  children,
  testId,
  describedBy,
  type = 'button',
}) => {
  const isOutline = variant === 'outline';
  const baseStyle = {
    flex: fullWidth ? undefined : 1,
    width: fullWidth ? '100%' : undefined,
    padding: '14px 18px',
    borderRadius: 12,
    fontSize: 15,
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
  };
  const variantStyle = isOutline
    ? {
        border: `1px solid ${disabled ? colors.divider : colors.accent.purple}`,
        background: 'transparent',
        color: disabled ? colors.textDisabled : colors.accent.purple,
        boxShadow: 'none',
      }
    : {
        border: 'none',
        background: disabled ? colors.surface : colors.accent.purple,
        color: disabled ? colors.textDisabled : colors.surfaceElevated,
        boxShadow: disabled ? 'none' : `0 0 30px ${colors.accent.purple}40`,
      };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      aria-describedby={describedBy}
      style={{ ...baseStyle, ...variantStyle }}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
